module.exports = __webpack_public_path__ + "static/media/Pin_TireInstall.9373ac98.svg";